<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">CONTENTS</h1>
<div class="SOM_pre"><a href="#/pre2">Preface</a></div>
<div class="SOM_pre"><a href="#/pre3">Introduction: What Is a Minority?</a></div>
<div class="SOM_part"><a href="#/p1">PART ONE: UNDERSTANDING THE MINORITY EXPERIENCE</a></div>
<div class="SOM_chap"><a href="#/p1chap1"><span class="mev1">1</span> Self-Doubt: Understanding Pain</a></div>
<div class="SOM_chap"><span href="#/p1chap2" title="Link target outside of Sample"><span class="mev5">2</span> Pain, Power, and the Past: Three Distinctives of the Minority Experience</span></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample"><span class="mev2">3</span> Domestication: Understanding Power</span></div>
<div class="SOM_chap"><span href="#/p1chap4" title="Link target outside of Sample"><span class="mev1">4</span> Weariness: Understanding the Past</span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">PART 2: REDEEMING THE MINORITY EXPERIENCE</span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample"><span class="mev2">5</span> Challenges in Organizational Development: How to Diversify Your Organization</span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><span class="mev1">6</span> Seeing Pain with Eyes of Compassion</span></div>
<div class="SOM_chap"><span href="#/p2chap3" title="Link target outside of Sample"><span class="mev5">7</span> Stewarding Power with Hands of Advocacy</span></div>
<div class="SOM_chap"><span href="#/p2chap4" title="Link target outside of Sample"><span class="mev2">8</span> Reframing the Past with a Heart of Wisdom</span></div>
<div class="SOM_chap"><span href="#/p2chap5" title="Link target outside of Sample"><span class="mev2">9</span> The Challenge and the Opportunity</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Study Guide</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Name and Subject Index</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Praise for <i>The Minority Experience</i></span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">About the author</span></div>
<div class="SOM_appen"><span href="#/moreIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
<div class="SOM_pdf"><span href="#/ident11#copy1" title="Link target outside of Sample">Copyright</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?3c1616c4